/**
 * Адреса для зовнішнього посилання: лише абсолютні http(s)-URL, інакше null.
 * Не дає перетворити на лінк довільний текст поля (напр. `javascript:`).
 */
export const safeExternalUrl = (value: unknown): string | null => {
    if (typeof value !== 'string') return null
    const trimmed = value.trim()
    if (trimmed === '') return null
    try {
        const url = new URL(trimmed)
        return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : null
    } catch {
        return null
    }
}
